import { render } from "./Logout.vue?vue&type=template&id=1ed1b43a&ts=true"
import script from "./Logout.vue?vue&type=script&lang=ts"
export * from "./Logout.vue?vue&type=script&lang=ts"

import exportComponent from "/home/runner/_work/SDD-gotime-web-client/SDD-gotime-web-client/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__